import axios from '@/api'

// Fonctions API
export const getReservations = () => axios.get('/training-reservations')
export const getReservation = (id) => axios.get(`/training-reservations/${id}`)
export const createReservation = (data) => axios.post('/training-reservations', data)
export const updateReservation = (id, data) => axios.put(`/training-reservations/${id}`, data)
export const deleteReservation = (id) => axios.delete(`/training-reservations/${id}`)
export const updateStatus = (id, status, data = {}) => axios.put(`/training-reservations/${id}/status/${status}`, data)
export const getReservationsByPeriod = (params) => axios.get('/training-reservations/period', { params })
export const getUserReservations = () => axios.get('/my-training-reservations')
